import React from 'react';
import { Box, Typography } from '@mui/material';
import MapTimelineContainer from '../timeline/MapTimelineContainer';
import { HourlyForecastTimelineData, ErrorInfo } from '../../models/HourlyForecastTimelineData';
import * as styles from '../../styles/MapPageStyles';

interface Airport {
  id: number;
  name: string;
  code: string;
}

interface ExtendedTimelineData extends HourlyForecastTimelineData {
  errors?: ErrorInfo[];
}

interface AirportTimelineSlotProps {
  selectedAirport: Airport | null;
  timelineData: ExtendedTimelineData | null;
}

const AirportTimelineSlot: React.FC<AirportTimelineSlotProps> = ({
  selectedAirport,
  timelineData
}) => {
  return (
    <Box sx={styles.timelineBoxStyles}>
      {selectedAirport ? (
        <MapTimelineContainer
          timelineData={timelineData}
          airportName={`${selectedAirport.name} (${selectedAirport.code})`}
          compact={true}
        />
      ) : (
        <Box sx={styles.noAirportSelectedContainerStyles}>
          <Typography variant="body2" sx={styles.noAirportSelectedTextStyles}>
            No airport selected
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default AirportTimelineSlot;